module.exports = __webpack_public_path__ + "media/images/svg/clients/16-c1af6f00453aa62a4c689d870cb81341.svg";